import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Context } from 'src/app/context';
import { BrandModel } from 'src/app/models/brand.model';

@Component({
  selector: 'app-ios-install',
  templateUrl: './ios-install.component.html',
  styleUrls: ['./ios-install.component.scss'],
})
export class IosInstallComponent implements OnInit {

  brand: BrandModel;
  browserName: string;

  constructor(
    private modalController: ModalController,
  ) {

  }

  ngOnInit() {
    this.brand = Context.brand;
    this.browserName = this.getBrowserName();
  }

  close() {
    this.modalController.dismiss();
  }

  private getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
    }
    return 'unknown';
  }

}
